import React from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import { Button } from 'antd';
import { FormattedMessage, injectIntl } from 'react-intl';
import Row from 'antd/lib/grid/row';
import { ConnectPayPalContainer, CustomPayPalIcon, ConnectToPayPal } from './styled';
import Checkout from '../../Checkout';
import { theme } from '../../../constants';

@injectIntl
@inject('onboardingStore')
@inject('settingsStore')
@observer
class PayPalCard extends React.Component {
  state = {
    payPalConnectionLoading: false,
    payPalConnectionSuccess: false,
    readyToConnect: false,
  };

  setReady = () => {
    this.setState({ readyToConnect: true });
  };

  render() {
    const {
      onboardingStore,
      primaryButtonProps,
      settingsStore: {
        subscription: { billingPaypalAccountId },
      },
    } = this.props;
    const { readyToConnect, payPalConnectionSuccess, payPalConnectionLoading } = this.state;
    if (!payPalConnectionSuccess && !billingPaypalAccountId) {
      onboardingStore.disableNextWizard();
    } else {
      onboardingStore.enableNextWizard();
    }
    return (
      <>
        <Row
          style={{
            justifyContent: 'center',
            marginTop: '12px',
            display: 'flex',
          }}
        >
          {payPalConnectionLoading && <div className="loader" />}
          {!readyToConnect && !payPalConnectionSuccess && (
            <ConnectPayPalContainer onClick={this.setReady}>
              <CustomPayPalIcon type="paypal" size={63} />
              <ConnectToPayPal>
                <FormattedMessage id="onboarding.screen5.connectPayPal" />
              </ConnectToPayPal>
            </ConnectPayPalContainer>
          )}
          {billingPaypalAccountId && (
            <Button {...primaryButtonProps}>
              <FormattedMessage id="onboarding.buttons.next" />
            </Button>
          )}
          {readyToConnect && (
            <Checkout
              beforeConnect={() => {
                this.setState({
                  payPalConnectionLoading: true,
                });
              }}
              afterConnect={() => {
                this.setState(
                  {
                    payPalConnectionLoading: false,
                    payPalConnectionSuccess: true,
                  },
                  () => {
                    if (primaryButtonProps.onClick) {
                      primaryButtonProps.onClick({ preventDefault: () => {} });
                    }
                  },
                );
              }}
              buttonCss={primaryButtonProps.css ? primaryButtonProps.css.styles : null}
            />
          )}
        </Row>
        <Row
          style={{
            position: 'absolute',
            bottom: '20px',
            textAlign: 'center',
            width: '100%',
            fontSize: theme.fontSize.medium,
          }}
        >
          <FormattedMessage id="onboarding.screen5.willNotChargeNotice" />
        </Row>
      </>
    );
  }
}

PayPalCard.propTypes = {
  onboardingStore: PropTypes.object,
  primaryButtonProps: PropTypes.object,
};

export default PayPalCard;
